import ReferralModal from 'library/services/expert-voice/expert-voice-referral-modal'
import { mountOnBody } from 'library/services/helpers'
import pick from 'lodash/pick'
import axios from 'axios'

# These are the query params we use from Expert Voice
requiredParams = [ '_t', '_auth', 'userKey' ]

# If the route query params look Expert Voice like, send request to apply their
# discount to current cart.
export handleExpertVoiceReferral = ({ store, router }) ->

	# Abort unless the request has all the Expert Voice params we use
	query = router.currentRoute.query
	return unless isExpertVoiceReferral query

	# Open the modal into a loading state
	modal = await mountOnBody ReferralModal

	# Hydrate the cart so we can get a cart id
	unless cart = await store.dispatch 'cart/fetchUnlessHydrated'
		console.error 'Cart not fetched'
		return modal.setErrorState()

	# Remove all query params so back button doesn't trigger re-approvals
	router.replace path: router.currentRoute.path

	# Make the Netlify function URL we'll be posting to
	endpoint = (process.env.NETLIFY_FUNCTIONS_URL || process.env.NUXT_APP_URL) +
		'/.netlify/functions/apply-expert-voice-discount'

	# Send the required params and the cart id
	try await axios.post endpoint, {
		...(pick query, requiredParams)
		cartId: cart.id
	}

	# Handle errors from authorization
	catch e then return switch e.response?.status
		when 403 then modal.setDeniedState()
		else modal.setErrorState()

	# Update cart to include newly set attribues
	try await store.dispatch 'cart/fetch'
	catch e then return modal.setErrorState()

	# If we made it this far, it was a succeess
	modal.setApprovedState()

# Check that the url query contains requried user voice keys
isExpertVoiceReferral = (query) ->
	queryKeys = Object.keys query
	return false unless requiredParams.every (param) -> queryKeys.includes(param)
	return query.orderType == 'B'

###
Expert Voice referral query params look like:
?discount=40.00
	&email=robert.reinhard%40bukwild.com
	&firstName=Robert
	&lastName=Reinhard
	&userKey=P4tWQxWm7pJAxQ2gPsgPHm98Y30%3D
	&orderType=B
	&_t=230728121138
	&_auth=7c89f1a2e2fc1c15316472211c4d35a427aed25d
###
